function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["aria-live", "aria-relevant", "aria-atomic", "className", "inversed", "inputClassName", "inputRef", "size", "checkedChildren", "uncheckedChildren"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import EvEmitter from 'ev-emitter';
import classNames from 'classnames';
import useId from '../utilities/useId';
import { InlineError } from '../InlineError';
import { Label } from '../Label';
import { useLabelProps } from '../Label/useLabelProps';
import { useHint } from '../Hint/useHint';
import cleanFieldProps from '../utilities/cleanFieldProps';
import describeField from '../utilities/describeField';
/** Used to emit events to all Choice components */
var dsChoiceEmitter = new EvEmitter();

/**
 * This component passes any additional props to its underlying input element
 * as attributes. See the corresponding MDN documentation for
 * [input](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input) for
 * a list of valid attributes.

 * For information about how and when to use this component, refer to the
 * [checkbox](https://design.cms.gov/components/checkbox/) and
 * [radio](https://design.cms.gov/components/radio/) documentation pages.
 */
export var Choice = function Choice(props) {
  var _props$checked;
  var initialCheckedState = (_props$checked = props.checked) !== null && _props$checked !== void 0 ? _props$checked : props.defaultChecked;
  var _useState = useState(initialCheckedState),
    _useState2 = _slicedToArray(_useState, 2),
    internalCheckedState = _useState2[0],
    setChecked = _useState2[1];
  var isControlled = props.checked !== undefined;
  var checked = isControlled ? props.checked : internalCheckedState;
  var radioCheckedEventName = "".concat(props.name, "-radio-checked");
  var id = useId('choice--', props.id);
  var _useHint = useHint(_objectSpread(_objectSpread({}, props), {}, {
      id: id
    })),
    hintId = _useHint.hintId,
    hintElement = _useHint.hintElement;
  var labelProps = useLabelProps(_objectSpread(_objectSpread({}, props), {}, {
    id: id
  }));
  var errorId;
  var errorElement;
  if (props.errorMessage) {
    var _props$errorId;
    errorId = (_props$errorId = props.errorId) !== null && _props$errorId !== void 0 ? _props$errorId : "".concat(props.id, "__error");
    errorElement = /*#__PURE__*/React.createElement(InlineError, {
      id: errorId,
      inversed: props.inversed,
      className: props.errorMessageClassName
    }, props.errorMessage);
  }

  // Subscribe to changes from other radio buttons in the same group
  useEffect(function () {
    // This logic only applies to uncontrolled radio groups
    if (props.type !== 'radio' || isControlled) {
      return;
    }
    var handleRadioChecked = function handleRadioChecked(checkedId) {
      // A radio button in this group was just checked. If it wasn't this one, uncheck this one
      if (checkedId !== id) {
        setChecked(false);
      }
    };
    dsChoiceEmitter.on(radioCheckedEventName, handleRadioChecked);
    return function () {
      dsChoiceEmitter.off(radioCheckedEventName, handleRadioChecked);
    };
  }, [setChecked]);
  function handleChange(event) {
    if (props.onChange) {
      props.onChange(event);
    }
    if (!isControlled) {
      setChecked(event.target.checked);
      if (props.type === 'radio' && event.target.checked) {
        // Emit an event so other radio options can uncheck themselves
        dsChoiceEmitter.emitEvent(radioCheckedEventName, [id]);
      }
    }
  }
  var ariaLive = props['aria-live'],
    ariaRelevant = props['aria-relevant'],
    ariaAtomic = props['aria-atomic'],
    className = props.className,
    inversed = props.inversed,
    inputClassName = props.inputClassName,
    inputRef = props.inputRef,
    size = props.size,
    checkedChildren = props.checkedChildren,
    uncheckedChildren = props.uncheckedChildren,
    inputProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "aria-live": ariaLive !== null && ariaLive !== void 0 ? ariaLive : checkedChildren ? 'polite' : null,
    "aria-relevant": ariaRelevant !== null && ariaRelevant !== void 0 ? ariaRelevant : checkedChildren ? 'additions text' : null,
    "aria-atomic": ariaAtomic !== null && ariaAtomic !== void 0 ? ariaAtomic : checkedChildren ? 'false' : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "ds-c-choice-wrapper"
  }, /*#__PURE__*/React.createElement("input", _extends({}, cleanFieldProps(inputProps), {
    id: id,
    className: classNames(inputClassName, 'ds-c-choice', {
      'ds-c-choice--inverse': inversed,
      'ds-c-choice--small': size === 'small'
    }),
    onChange: handleChange,
    ref: inputRef,
    "aria-describedby": describeField(_objectSpread(_objectSpread({}, props), {}, {
      errorId: errorId,
      hintId: hintId
    }))
  })), /*#__PURE__*/React.createElement(Label, _extends({}, labelProps, {
    fieldId: id
  })), hintElement, errorElement), checked ? checkedChildren : uncheckedChildren);
};
export default Choice;